module.exports = __webpack_public_path__ + "static/media/SLIM.ed91018f.svg";